(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('select[data-growhaus-area-sort]')) return;
    const destination = new URL(window.location.href);
    destination.searchParams.set('sort_by', event.target.value);
    window.location.assign(destination.toString());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["growhaus-area-hub"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.location.hash) return;
    const target = document.querySelector(window.location.hash);
    if (!target || !target.classList.contains('gah__card')) return;
    const menu = target.querySelector('details');
    if (menu) menu.setAttribute('open', '');
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["growhaus-ask-daisy"] && !Shopify.designMode) return;
  try {
    
  const daisyFileToDataUrl = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
  const daisyAddList = (parent, title, items) => {
    if (!Array.isArray(items) || !items.length) return;
    const heading = document.createElement('h4');
    heading.textContent = title;
    const list = document.createElement('ul');
    items.forEach((item) => {
      const row = document.createElement('li');
      row.textContent = typeof item === 'string' ? item : item.question || item.cause || item.reason || '';
      list.appendChild(row);
    });
    parent.append(heading, list);
  };
  const daisyRenderResult = (container, result) => {
    container.replaceChildren();
    const title = document.createElement('h3');
    title.textContent = result.stage === 'recommendation' ? 'A practical path forward' : 'A few questions before dAIsy recommends a path';
    const summary = document.createElement('p');
    summary.textContent = result.summary || '';
    container.append(title, summary);
    daisyAddList(container, 'What dAIsy needs to know', result.follow_up_questions);
    daisyAddList(container, 'Possible causes to investigate', result.possible_causes);
    daisyAddList(container, 'Low-risk next steps', result.immediate_actions);
    daisyAddList(container, 'Checks that will narrow it down', result.checks_to_confirm);
    if (result.safety_note) {
      const note = document.createElement('p');
      note.textContent = result.safety_note;
      container.appendChild(note);
    }
    container.hidden = false;
    container.scrollIntoView({behavior: 'smooth', block: 'nearest'});
  };
  const daisyInit = (section) => {
    if (section.dataset.daisyReady === 'true') return;
    section.dataset.daisyReady = 'true';
    const topicInput = section.querySelector('[data-daisy-topic-input]');
    const question = section.querySelector('[data-daisy-question]');
    const humanQuestion = section.querySelector('[data-daisy-human-question]');
    const form = section.querySelector('[data-daisy-ai-form]');
    const status = section.querySelector('[data-daisy-status]');
    const result = section.querySelector('[data-daisy-result]');
    const photo = section.querySelector('[data-daisy-photo]');
    const fileStatus = section.querySelector('[data-daisy-file-status]');
    const mic = section.querySelector('[data-daisy-mic]');
    let recorder;
    let audioChunks = [];
    section.querySelectorAll('[data-daisy-topic]').forEach((button) => {
      button.addEventListener('click', () => {
        topicInput.value = button.dataset.daisyTopic;
        question.placeholder = button.dataset.daisyPrompt;
        question.focus({preventScroll: true});
        section.querySelector('.daisy__workspace').scrollIntoView({behavior: 'smooth', block: 'start'});
      });
    });
    photo?.addEventListener('change', () => {
      const file = photo.files[0];
      if (!file) fileStatus.textContent = '';
      else if (file.size > 2000000) {
        photo.value = '';
        fileStatus.textContent = 'Choose an image under 2 MB.';
      } else fileStatus.textContent = `${file.name} ready to review.`;
    });
    mic?.addEventListener('click', async () => {
      const endpoint = section.dataset.transcriptionEndpoint;
      if (!endpoint) {
        status.textContent = 'Voice input will turn on when the secure dAIsy connection is deployed.';
        return;
      }
      if (recorder?.state === 'recording') {
        recorder.stop();
        mic.setAttribute('aria-pressed', 'false');
        mic.lastChild.textContent = ' Describe by voice';
        return;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({audio: true});
        recorder = new MediaRecorder(stream);
        audioChunks = [];
        recorder.addEventListener('dataavailable', (event) => audioChunks.push(event.data));
        recorder.addEventListener('stop', async () => {
          stream.getTracks().forEach((track) => track.stop());
          status.textContent = 'Transcribing your description…';
          try {
            const audio = await daisyFileToDataUrl(new Blob(audioChunks, {type: recorder.mimeType || 'audio/webm'}));
            const response = await fetch(endpoint, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({audio})});
            const data = await response.json();
            if (!response.ok) throw new Error(data.error);
            question.value = [question.value, data.text].filter(Boolean).join(' ');
            humanQuestion.value = question.value;
            status.textContent = 'Voice description added. Review it, then ask dAIsy.';
          } catch (error) {
            status.textContent = error.message || 'The recording could not be transcribed.';
          }
        });
        recorder.start();
        mic.setAttribute('aria-pressed', 'true');
        mic.lastChild.textContent = ' Stop recording';
        status.textContent = 'Listening… select Stop recording when you are finished.';
        window.setTimeout(() => { if (recorder?.state === 'recording') recorder.stop(); }, 60000);
      } catch (error) {
        status.textContent = 'Microphone access was not available. You can type the description instead.';
      }
    });
    question?.addEventListener('input', () => { humanQuestion.value = question.value; });
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const endpoint = section.dataset.assistantEndpoint;
      if (!endpoint) return;
      const submit = form.querySelector('[type=submit]');
      submit.disabled = true;
      status.textContent = 'dAIsy is reviewing the evidence and deciding what to ask next…';
      result.hidden = true;
      try {
        const images = photo?.files[0] ? [await daisyFileToDataUrl(photo.files[0])] : [];
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({topic: topicInput.value, problem: section.querySelector('[data-daisy-problem]').value, facility: section.querySelector('[data-daisy-facility]').value, question: question.value, images})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error);
        daisyRenderResult(result, data.result);
        status.textContent = 'This is an AI-assisted assessment. Verify important decisions with your Growhaus advisor and facility QA team.';
      } catch (error) {
        status.textContent = error.message || 'dAIsy could not complete that request. Open the Growhaus advisor form below for help.';
      } finally {
        submit.disabled = false;
      }
    });
  };
  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-ask-daisy]').forEach(daisyInit));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ask-daisy]').forEach(daisyInit));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["growhaus-collective"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-ghcollective]').forEach((root) => {
    const data = JSON.parse(root.querySelector('[data-products]').textContent);
    const selected = new Map();
    let customCounter = 0;

    const choiceButtons = Array.from(root.querySelectorAll('[data-intake-choice]'));
    const panels = Array.from(root.querySelectorAll('[data-intake-panel]'));
    const showPanel = (key) => {
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.intakePanel !== key;
      });
      choiceButtons.forEach((button) => {
        const active = button.dataset.intakeChoice === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    choiceButtons.forEach((button) => {
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => showPanel(button.dataset.intakeChoice));
    });

    if (root.querySelector('.ghcollective__success')) showPanel('list');

    const rowsHost = root.querySelector('[data-sheet-rows]');
    const customHost = root.querySelector('[data-custom-products]');
    const search = root.querySelector('[data-sheet-search]');
    const filters = Array.from(root.querySelectorAll('[data-sheet-filter]'));
    const empty = root.querySelector('[data-sheet-empty]');
    const count = root.querySelector('[data-selected-count]');
    const fit = root.querySelector('fieldset:nth-of-type(3)');
    let activeFilter = '';

    const field = (type, value, placeholder, aria) => {
      const input = document.createElement('input');
      input.type = type;
      input.value = value || '';
      input.placeholder = placeholder || '';
      if (aria) input.setAttribute('aria-label', aria);
      if (type === 'number') {
        input.min = '0';
        input.step = '1';
        input.inputMode = 'numeric';
      }
      return input;
    };

    const updateCount = () => {
      if (count) count.textContent = String(selected.size);
    };

    const setSelected = (key, record) => {
      if (Number(record.qty || 0) > 0) selected.set(key, record);
      else selected.delete(key);
      updateCount();
    };

    const makeCell = (label, child, className) => {
      const wrap = document.createElement('label');
      wrap.className = 'ghcollective__sheet-cell ' + (className || '');
      const caption = document.createElement('span');
      caption.className = 'ghcollective__cell-label';
      caption.textContent = label;
      wrap.append(caption, child);
      return wrap;
    };

    const makeCatalogRow = (cat, item) => {
      const key = item.sku + ' — ' + item.name;
      const record = {custom:false, category:cat.category, slug:cat.slug, sku:item.sku, name:item.name, pack:item.pack, qty:'', price:'', supplier:''};
      const row = document.createElement('div');
      row.className = 'ghcollective__sheet-row';
      row.dataset.sheetCategory = cat.slug;
      row.dataset.sheetSearch = (item.sku + ' ' + item.name + ' ' + cat.category).toLowerCase();

      const product = document.createElement('div');
      product.className = 'ghcollective__sheet-product';
      const strong = document.createElement('strong');
      strong.textContent = item.name;
      const small = document.createElement('small');
      small.textContent = item.sku + ' · ' + cat.category;
      product.append(strong, small);

      const pack = document.createElement('div');
      pack.className = 'ghcollective__sheet-pack';
      pack.textContent = item.pack;

      const qty = field('number', '', '0', 'Monthly quantity for ' + item.name);
      qty.className = 'ghcollective__qty-entry';
      qty.addEventListener('input', () => {
        record.qty = qty.value;
        row.classList.toggle('has-qty', Number(qty.value || 0) > 0);
        setSelected(key, record);
      });

      const price = field('text', '', '$ / pack', 'Current price for ' + item.name);
      price.addEventListener('input', () => {
        record.price = price.value;
        setSelected(key, record);
      });

      const supplier = field('text', '', 'Supplier', 'Current supplier for ' + item.name);
      supplier.addEventListener('input', () => {
        record.supplier = supplier.value;
        setSelected(key, record);
      });

      row.append(
        product,
        pack,
        makeCell('Qty / month', qty, 'ghcollective__sheet-qty'),
        makeCell('Current price', price, 'ghcollective__sheet-price'),
        makeCell('Supplier', supplier, 'ghcollective__sheet-supplier')
      );
      return row;
    };

    data.forEach((cat) => cat.items.forEach((item) => rowsHost.appendChild(makeCatalogRow(cat, item))));

    const applyFilter = () => {
      const term = (search && search.value || '').trim().toLowerCase();
      let visible = 0;
      rowsHost.querySelectorAll('[data-sheet-search]').forEach((row) => {
        const categoryMatch = !activeFilter || row.dataset.sheetCategory === activeFilter;
        const searchMatch = !term || row.dataset.sheetSearch.includes(term);
        const show = categoryMatch && searchMatch;
        row.hidden = !show;
        if (show) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.sheetFilter || '';
        filters.forEach((item) => item.classList.toggle('is-active', item === button));
        applyFilter();
      });
    });
    if (search) search.addEventListener('input', applyFilter);

    root.querySelector('[data-add-custom]').addEventListener('click', () => {
      customCounter += 1;
      const key = 'custom-' + customCounter;
      const record = {custom:true, category:'Outside Growhaus catalog', slug:'outside', sku:'', name:'', pack:'', qty:'', price:'', supplier:''};

      const row = document.createElement('div');
      row.className = 'ghcollective__sheet-row ghcollective__sheet-row--custom';

      const name = field('text', '', 'Product / brand', 'Product or brand');
      name.addEventListener('input', () => record.name = name.value);
      const product = document.createElement('div');
      product.className = 'ghcollective__sheet-product ghcollective__sheet-product--custom';
      product.appendChild(name);
      const small = document.createElement('small');
      small.textContent = 'Product not listed';
      product.appendChild(small);

      const pack = field('text', '', 'Pack size', 'Pack size');
      pack.addEventListener('input', () => record.pack = pack.value);
      const packWrap = document.createElement('div');
      packWrap.className = 'ghcollective__sheet-pack ghcollective__sheet-pack--input';
      packWrap.appendChild(pack);

      const qty = field('number', '', '0', 'Monthly quantity');
      qty.className = 'ghcollective__qty-entry';
      qty.addEventListener('input', () => {
        record.qty = qty.value;
        row.classList.toggle('has-qty', Number(qty.value || 0) > 0);
        setSelected(key, record);
      });

      const price = field('text', '', '$ / pack', 'Current price');
      price.addEventListener('input', () => { record.price = price.value; setSelected(key, record); });
      const supplier = field('text', '', 'Supplier', 'Current supplier');
      supplier.addEventListener('input', () => { record.supplier = supplier.value; setSelected(key, record); });

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'ghcollective__remove-custom';
      remove.textContent = '×';
      remove.setAttribute('aria-label', 'Remove product');
      remove.addEventListener('click', () => {
        selected.delete(key);
        row.remove();
        updateCount();
      });

      row.append(
        product,
        packWrap,
        makeCell('Qty / month', qty, 'ghcollective__sheet-qty'),
        makeCell('Current price', price, 'ghcollective__sheet-price'),
        makeCell('Supplier', supplier, 'ghcollective__sheet-supplier'),
        remove
      );
      customHost.appendChild(row);
      name.focus();
    });

    const continueButton = root.querySelector('[data-continue-fit]');
    const fitFieldset = root.querySelector('.ghcollective__form fieldset:nth-of-type(3)');
    if (continueButton && fitFieldset) {
      continueButton.addEventListener('click', () => fitFieldset.scrollIntoView({behavior:'smooth', block:'start'}));
    }

    updateCount();
    applyFilter();

    const form = root.querySelector('.ghcollective__form');
    const summary = root.querySelector('[data-summary]');
    if (form && summary) form.addEventListener('submit', () => {
      const val = (k) => {
        const f = form.querySelector('[data-field="' + k + '"]');
        if (!f) return '';
        if (f.type === 'checkbox') return f.checked ? 'Yes' : 'No';
        return f.value.trim();
      };
      const lines = Array.from(selected.values()).map((x) => [
        x.category || '',
        x.sku || '',
        x.name || 'Unnamed product',
        'Pack ' + (x.pack || 'not entered'),
        'Qty/month ' + (x.qty || 'not entered'),
        'Current price ' + (x.price || 'not entered'),
        'Current supplier ' + (x.supplier || 'not entered')
      ].join(' | '));
      summary.value = [
        'GROWHAUS COLLECTIVE — FOUNDING MEMBER FORECAST',
        '',
        'Facilities/locations: ' + val('facilities'),
        'Forecast period: ' + val('period'),
        'Commitment: ' + val('commitment'),
        'Brand flexibility: ' + val('flexibility'),
        '',
        'CURRENT PURCHASES / FORECAST (' + lines.length + ')',
        lines.length ? lines.join('\n') : 'No products entered.',
        '',
        'ADDITIONAL NOTES',
        val('notes') || 'None entered.'
      ].join('\n');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
